import { takeLatest, put, call, select } from "redux-saga/effects";
import {
    GET_COMPANIES_REQUEST,
    getCompaniesSuccess,
    getCompaniesFailure,
    SUBMIT_COMPANY_REQUEST,
    submitCompanySuccess,
    submitCompanyFailure,
    GET_COMPANY_REQUEST,
    getCompanySuccess,
    getCompanyFailure,
    testEmailSuccess,
    testEmailFailure,
    TEST_EMAIL_REQUEST,
    GET_PLANS_REQUEST,
    getPlansSuccess,
    getPlansFailure,
    GET_COMPANY_PLANS_REQUEST,
    getCompanyPlansSuccess,
    getCompanyPlansFailure
} from "../actions/company";
import { companyAccessor } from "../selectors/company";
import { getCompanies, postCompanies, putCompanies, postTestEmailCompany, getPlans, getCompanyPlans} from "../services/company";
import { showGlobalError } from "../../app/actions/app";
import { accessTokenSelector } from "../../auth/selectors/token";

export const getCompaniesWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);

        const { companies: _companies } = yield select(companyAccessor);

        if (!_companies.length) {
            const {
                data: { companies, total }
            } = yield call(getCompanies, filters, token);
            yield put(getCompaniesSuccess(companies, total));
        } else {
            yield put(getCompaniesSuccess());
        }
    } catch (err) {
        yield put(getCompaniesFailure(err));
        yield put(showGlobalError(true, err));
    }
};

export const getCompanyWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);

        const {
            data: { companies, total }
        } = yield call(getCompanies, filters, token);

        yield put(getCompanySuccess(companies[0] || {}, total));

    } catch (err) {
        yield put(getCompanyFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getPlansWorker = function* () {
    try {
        const token = yield select(accessTokenSelector);

        const response = yield call(getPlans, token);
        const { data: { plans } } = response;
        yield put(getPlansSuccess(plans));
    } catch (err) {
        yield put(getPlansFailure(err));
        yield put(showGlobalError(true, err));
    }
}

const submitCompanyWorker = function* ({ payload: { company } }) {
    try {
        const token = yield select(accessTokenSelector);

        if (!company._id) {
            yield call(postCompanies, company, token);
            yield put(submitCompanySuccess());
            yield put(showGlobalError(true, 200, 'created'));
        } else {
            yield call(putCompanies, company, token);
            yield put(submitCompanySuccess());
            yield put(showGlobalError(true, 200, 'updated'));
        }
    } catch (err) {
        console.log(err);
        yield put(submitCompanyFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const testEmailCompany = function* ({payload:{companyId, testEmail}}) {

    try{
        const token = yield select(accessTokenSelector);
        yield call(postTestEmailCompany, testEmail, companyId, token);
        yield put(testEmailSuccess());
        yield put(showGlobalError(true, 200, `sent_email`))
    } catch (err) {
        console.log(err)
        yield put(testEmailFailure(err));
        yield put(showGlobalError(true, err))
    }
}

const getCompanyPlansWorker = function* ({ payload: { companyId } }) {
    try {
        const token = yield select(accessTokenSelector);

        const {
            data: { company }
          } = yield call(getCompanyPlans, companyId, token);
          
          yield put(
            getCompanyPlansSuccess(company, company.plans, company.plans.length)
          );
          
    } catch (err) {
        yield put(getCompanyPlansFailure(err));
        yield put(showGlobalError(true, err));
    }
};

export default [
    takeLatest(GET_COMPANIES_REQUEST, getCompaniesWorker),
    takeLatest(GET_COMPANY_REQUEST, getCompanyWorker),
    takeLatest(SUBMIT_COMPANY_REQUEST, submitCompanyWorker),
    takeLatest(TEST_EMAIL_REQUEST, testEmailCompany),
    takeLatest(GET_PLANS_REQUEST, getPlansWorker),
    takeLatest(GET_COMPANY_PLANS_REQUEST, getCompanyPlansWorker)
];
